export const RESOURCE = 'Resources';
export const OTHERS = 'Others';
export const ADMIN = 'Administration';
export const MY_INFO = 'My Info';
export const CHANGE_PASSWORD = 'Change Password';
export const SWITCH_ACCOUNT = 'Switch Account';
export const IMPERSONATE = 'Impersonate';
export const MY_PREFERENCE = 'Preferences';
export const LOGOUT = 'Logout';
export const COMING_SOON = 'Coming Soon';
export const SUPPORT = 'Support';
export const ANALYTICS = 'Analytics';
export const INSIGHT = 'Insights';
export const DATA = 'Data';
export const QUICK_REPORTS = 'Quick Reports';
export const CROSSTAB = 'Crosstab';
export const DATAHAUL = 'DataHaul';
export const CORRESPONDENCE = 'Correspondence';
export const CLUSTER = 'Cluster';
export const DATASTREAM = 'DataStream';
export const GEO_MAPPING = 'Geo Mapping';
export const REACH_AND_FREQUENCY = 'Reach & Frequency';
export const CONTRACT_ADMIN = 'Contract Administration';
export const RLD_TOOL = 'RLD Tool';
export const CROSSTAB_V2 = 'Crosstab 2.0';
export const COMPOSER = 'Composer';
export const DATA_APPEND = 'Data Append';
export const PROFILE_INSIGHTS = 'Profile Insights';
